<div>
  <!-- SEÇÃO INFORMAÇÕES PRINCIPAIS -->
  <section>
    <p class="section-title">INFORMAÇÕES PRINCIPAIS</p>

    <!-- Nome grupo -->
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Nome do grupo</mat-label>
      <input matInput [(ngModel)]="formData.nomeGrupo" (ngModelChange)="updateForm('nomeGrupo', $event)"
        [ngModelOptions]="{standalone: true}" placeholder="Nome do grupo*" [disabled]="readOnly" required />
    </mat-form-field>
  </section>

  <div class="spacer" style="height: 1em"></div>

  <!-- SEÇÃO CONTATO DO GRUPO -->
  <section>
    <p class="section-title">CONTATO DO GRUPO</p>

    <mat-grid-list cols="4" rowHeight="85px" gutterSize="1em">
      <!-- Nome completo -->
      <mat-grid-tile colspan="2">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Nome completo</mat-label>
          <input matInput [(ngModel)]="formData.nomeCompleto" (ngModelChange)="updateForm('nomeCompleto', $event)"
            [ngModelOptions]="{standalone: true}" placeholder="Nome completo*" [disabled]="readOnly" required />
        </mat-form-field>
      </mat-grid-tile>

      <!-- Email -->
      <mat-grid-tile colspan="2">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>E-mail</mat-label>
          <input matInput [(ngModel)]="formData.email" (ngModelChange)="updateForm('email', $event)"
            [ngModelOptions]="{standalone: true}" placeholder="E-mail*" [disabled]="readOnly" required />
        </mat-form-field>
      </mat-grid-tile>

      <!-- Cargo -->
      <mat-grid-tile colspan="2">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Cargo</mat-label>
          <input matInput [(ngModel)]="formData.cargo" (ngModelChange)="updateForm('cargo', $event)"
            [ngModelOptions]="{standalone: true}" placeholder="Cargo*" [disabled]="readOnly" required />
        </mat-form-field>
      </mat-grid-tile>

      <!-- Telefone -->
      <mat-grid-tile colspan="2">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Telefone celular</mat-label>
          <input matInput [(ngModel)]="formData.telefoneCelular" (ngModelChange)="updateForm('telefoneCelular', $event)"
            [ngModelOptions]="{standalone: true}" placeholder="(00) 00000-0000" mask="(00) 00000-0000" [disabled]="readOnly" required />
        </mat-form-field>
      </mat-grid-tile>
    </mat-grid-list>
  </section>

  <section style="display: flex; flex-direction: row; justify-content: flex-end; gap: 1em;" *ngIf="!readOnly">
    <button matButton="outlined">Cancelar</button>
    <button matButton="filled" (click)="onSalvar()">Salvar</button>
  </section>
</div>